import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-datepicker/dist/react-datepicker.css";
import "rc-time-picker/assets/index.css";
import "react-toggle/style.css";
import "./app/assets/css/header.css";
import "./app/assets/css/footer.css";
import "./app/assets/css/home.css";
import "./app/assets/css/auth.css";
import "./app/assets/css/home-auth.css";
import "./app/assets/css/events.css";
import "./app/assets/css/discover.css";
import "./app/assets/css/blogs.css";
import "./app/assets/css/settings.css";
import "./app/assets/css/interactions.css";
import "./app/assets/css/profile.css";
import "./app/assets/css/notification.css";
// import "./app/components/ChatSection/Chat.css";
import App from "./routes/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import Store from "./redux/store";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
